import { isReturnSourceType } from "../config/returnKinds";

export type InwardAction = "CREATE" | "EDIT" | "DETAIL" | "";

export interface InwardRouteInput {
  pathname: string;
  /** location.state của react-router, có thể null khi mở ở tab mới hoặc F5 */
  state: unknown;
  /** location.search, ví dụ "?sourceType=NHAP_DOI_TRA&isLocked=true" */
  search: string;
}

export interface InwardRoute {
  action: InwardAction;
  sourceType: string | null;
  sourceCode: string | null;
  transactionCode: string | null;
  id: number | string | null;
  isLocked: boolean;
  branchCode: string | null;
  /**
   * true khi phiếu do trang nhập đổi trả xử lý (NHAP_DOI_TRA) và có thứ để mở
   * (tạo mới cần số chứng từ, sửa / xem cần id). Còn lại vẫn mở trang nhập kho cũ như trước.
   */
  isReturn: boolean;
}

type RouteState = {
  sourceCode?: string | null;
  sourceType?: string | null;
  transactionCode?: string | null;
  isLocked?: boolean | null;
  id?: number | string | null;
  branchCode?: string | null;
};

const asRouteState = (state: unknown): RouteState | null =>
  state && typeof state === "object" ? (state as RouteState) : null;

const ACTION_BY_PATH: Record<string, InwardAction> = {
  "/warehouse-config/create-warehouse-in-ward": "CREATE",
  "/warehouse-config/edit-warehouse-in-ward": "EDIT",
  "/warehouse-config/detail-warehouse-in-ward": "DETAIL",
};

/**
 * Đọc tham số của 3 route create/edit/detail-warehouse-in-ward, cùng thứ tự ưu tiên trang nhập kho cũ
 * đang đọc (location.state trước, query string sau).
 */
export const resolveInwardRoute = ({ pathname, state, search }: InwardRouteInput): InwardRoute => {
  const routeState = asRouteState(state);
  const query = new URLSearchParams(search);
  const action = ACTION_BY_PATH[pathname] ?? "";
  const sourceType = routeState?.sourceType || query.get("sourceType") || null;
  // sourceCode, id, branchCode chỉ đến từ state, như trang cũ
  const sourceCode = routeState?.sourceCode || null;
  const id = routeState?.id ?? null;

  const hasTarget = action === "CREATE" ? !!sourceCode : !!id;

  return {
    action,
    sourceType,
    sourceCode,
    transactionCode: routeState?.transactionCode ?? query.get("transactionCode"),
    // isLocked: false trong state vẫn được giữ, chỉ rơi xuống query khi state không có giá trị
    isLocked: routeState?.isLocked ?? query.get("isLocked") === "true",
    id,
    branchCode: routeState?.branchCode || null,
    isReturn: isReturnSourceType(sourceType) && action !== "" && hasTarget,
  };
};
